export default __webpack_public_path__ + "a4606f2fb36af5fd3e34b59f5098dfad.png";